'use client'

import { useFeatureFlagsStore } from '../../store'
import type { IFeatureFlagProps } from './feature-flag.types'

export const FeatureFlag = (props: IFeatureFlagProps) => {
  const { flagKey, children, fallback = null } = props

  // Handle 'allow' special case
  if (flagKey === 'allow') {
    return children
  }

  const { flags } = useFeatureFlagsStore()

  // Helper function to check nested flag value
  const checkNestedFlag = (keys: string[], flagData: any): boolean => {
    let current = flagData
    for (const key of keys) {
      if (current && typeof current === 'object' && key in current) {
        current = current[key]
      } else {
        return false
      }
    }
    return current?.disabled === false
  }

  // Check if the flag exists and is enabled
  let isFlagEnabled = false

  if (typeof flagKey === 'string') {
    // Original logic for string input
    isFlagEnabled = flags?.[flagKey]?.value?.disabled === false
  } else if (Array.isArray(flagKey)) {
    // New logic for array input - navigate through nested structure
    isFlagEnabled = checkNestedFlag(flagKey, flags)
  }

  // Return children if flag is enabled, otherwise return fallback (default: null)
  return isFlagEnabled ? children : fallback
}
